import { NgModule } from '@angular/core';
import { ActionButtonModule } from '../../action-button/action-button.module';
import { TranslateModule } from '@ngx-translate/core';
import { MonitoringProfileSettingsComponent } from './monitoring-profile-settings/monitoring-profile-settings.component';
import { IntrackFeatureModule } from '../../../intrack-feature.module';
import { MonitoringProfileSubscriptionComponent } from './monitoring-profile-subscription/monitoring-profile-subscription.component';
import { ChipFieldModule } from '../../chip-field';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';

@NgModule({
  imports: [IntrackFeatureModule, ActionButtonModule, TranslateModule.forChild({}), ChipFieldModule, SvgIconModule],
  declarations: [MonitoringProfileSettingsComponent, MonitoringProfileSubscriptionComponent],
  exports: [MonitoringProfileSettingsComponent, MonitoringProfileSubscriptionComponent],
})
export class MonitoringProfilesModule {}
